import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StaticRoutes } from './static.routes';
import { TermsComponent } from './terms/terms.component';
import { PolicyComponent } from './policy/policy.component';

@NgModule({
  declarations: [
    TermsComponent,
    PolicyComponent
  ],
  imports: [
    RouterModule.forChild(StaticRoutes),
  ]
})
export class StaticModule {

}
